export default "__VITE_PUBLIC_ASSET__1f0a1c64__"